

















































































import { Vue, Component } from "vue-property-decorator";
import ClaimViewBaseComponent from "./ClaimViewBaseComponent";
import NewMessageComponent from "@/components/vcponlineok/staff-user/new-message-component.vue";
import { VcClaimMessageDto } from "@/asdcom/apiproxy/apiproxy.dto";
import { IHeader } from "@/store/models/staff/IHeader";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({
  components: {
    NewMessageComponent
  }
})
export default class Messages extends ClaimViewBaseComponent {
  isItemView: boolean = false;
  isMessageMarkedAsRead: boolean = false;
  messagesList: VcClaimMessageDto[] = [];

  created() {
    this.getMessages();
    if (this.$route.params.new == "new") {
      this.isItemView = true;
    }
  }

  mounted() {
    bus.$on("newMessage", () => {
      this.openNewMessage();
    })
    bus.$on("toListView", () => {
      this.isItemView = false;
    })
  }
  destroyed() {
    bus.$off("newMessage");
    bus.$off("toListView");
  }

  openNewMessage() {
    if (this.$route.name !== " Messages" && this.$route.params.new !== "new") {
      this.$router.push({name: "Messages", params: {new: "new"}});
    }
    this.isItemView = true;
  }

  async getMessages() {
    const unsortedMsgList = await this.$appsvs.vcpOnlineOkStaff.retrieveVcClaimMessages(this.vcClaimNumber);
    this.messagesList = unsortedMsgList.sort(
      (a: any, b: any) => {
          if (a["creationTime"] > b["creationTime"]) return -1
          if (a["creationTime"] < b["creationTime"]) return 1
          return 0
      }
    )
  }

  async markMessageAsRead(message: VcClaimMessageDto) {
    if (!message.messageProcessedByStaffUser) {
      this.$appsvs.vcpOnlineOkStaff.markClaimMessageAsProcessed(message.id)
        .then((res: any) => {
          this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
          this.getMessages();
        })
    }
  }

  onCloseItemView() {
    this.getMessages();
    this.isItemView = false;
    this.$router.push({name: "Messages"})
  }
}
